import { fetchAuthenticated } from '../fetch/fetchAuthenticated'
import { getStoredAwc } from './awin-utils'

/**
 * Send the stored AWC to the backend API
 * Fails silently as this is a non-critical operation
 */
export async function sendAwcToBackend(): Promise<void> {
  try {
    const awc = getStoredAwc()

    if (!awc) {
      console.log('No AWC found to send to backend')
      return
    }

    console.log('Sending AWC to backend:', awc)

    const response = await fetchAuthenticated('awc', {
      method: 'POST',
      body: JSON.stringify({ awc }),
    })

    if (response.ok) {
      console.log('Successfully sent AWC to backend')
    } else {
      console.warn('Failed to send AWC to backend:', response.status)
    }
  } catch (error) {
    // Fail silently - AWC tracking is non-critical
    console.error('Error sending AWC to backend:', error)
  }
}
